export default "/_next/static/media/lobby-header-desktop.d5e5ae9bcbc25f09b7144ac95b596047.mp4";